import React from "react";
import { Link } from "react-router-dom";

const BlogCard = ({ article }) => {
    const getCategoryColor = (category) => {
        const colorMap = {
            "Design Web": "#4A6FFF",
            "SEO": "#FF6B35",
            "Développement Mobile": "#8A4FFF",
            "Innovation": "#00BFB2",
            "E-commerce": "#FF4A6F",
            "Développement Web": "#3772FF",
            "Marketing Digital": "#FF9F1C",
            "Cybersécurité": "#D62828",
            "Transformation Digitale": "#558B6E",
            "Green IT": "#57A773"
        };

        return colorMap[category] || "#6B46C1"; // Utilise la couleur purple de base si la catégorie n'est pas trouvée
    };

    return (
        <Link to={`/blog/${article.slug}`} className="block h-full">
            <div className="flex flex-col h-full">
                <div className="relative h-48 overflow-hidden rounded-xl">
                    <img
                        src={article.image}
                        alt={article.title}
                        className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                        loading="lazy" // Pour améliorer les performances
                    />
                </div>
                <div className="pt-5 flex-grow flex flex-col">
                    <div className="mb-3 text-sm text-gray-500 flex items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                        <time dateTime={article.date}>
                            {new Date(article.date).toLocaleDateString('fr-FR', {
                                day: 'numeric',
                                month: 'long',
                                year: 'numeric'
                            })}
                        </time>
                    </div>
                    <h3 className="text-lg font-bold mb-3 text-gray-800 line-clamp-2 hover:text-purple-600 transition-colors">
                        {article.title}
                    </h3>
                    <div>
                        <span className={`inline-block px-3 py-1 text-xs font-medium backdrop-blur-sm rounded-full`} style={{
                            backgroundColor: `${getCategoryColor(article.category)}20`,
                            color: getCategoryColor(article.category)
                        }}>
                            {article.category}
                        </span>
                    </div>
                </div>
            </div>
        </Link>
    );
};

export default BlogCard;
